<template>
  <nav
    v-show="isNavBarVisible"
    class="navbar fixed flex bg-white border-b w-full transition-position xl:pl-60 lg:w-auto lg:items-stretch dark:bg-gray-900 dark:border-gray-800"
    :class="[lightBorderStyle, { 'ml-60 lg:ml-0': isAsideMobileExpanded },]"
  >
    <div class="flex-1 items-stretch flex h-14">
      <nav-bar-item
        class="flex md:hidden text-pink-250"
        @click.prevent="menuToggleMobile"
      >
        <icon :path="menuToggleMobileIcon" size="24" />
      </nav-bar-item>
      <nav-bar-item
        class=" navBarToggle mt-4 text-pink-250"
        @click.prevent="menuOpenLg"
      >
        <icon :path="menuToggleMobileIcon" size="24" />
      </nav-bar-item>
      <span class="text-gray-250 flex pl-4 font-medium text-base mt-5 w-72">
        <img
          src="@/assets/icons/hospital-logo.svg"
          class="justify-left w-10 h-10 items-left mr-2 border-2 border-gray-150 rounded-full"
        />
        <span class="mt-1 font-semibold">Search Hospitals</span>
      </span>
    </div>

    <div class="flex-none items-stretch flex h-14 lg:hidden">
      <nav-bar-item @click.prevent="menuNavBarToggle">
        <icon :path="menuNavBarToggleIcon" size="24" />
      </nav-bar-item>
    </div>
    <div
      class="absolute w-screen top-14 left-0 bg-white shadow lg:w-auto lg:items-stretch lg:flex lg:grow lg:static lg:border-b-0 lg:overflow-visible lg:shadow-none dark:bg-gray-900"
      :class="[isMenuNavBarActive ? 'block' : 'hidden']"
    >
      <div
        class="max-h-screen-menu overflow-y-auto lg:overflow-visible lg:flex lg:items-stretch lg:justify-end lg:ml-auto"
      >
        <!-- <div class="pt-4 px-2 w-full flex">
          <control-list
            type="text"
            class="text-sm w-48 mx-2"
            placeholder="Select State"
            v-model="currentState"
            :options="stateitems"
            @change="loadDistrict"
          />
          <control-list
            type="text"
            class="text-sm w-48 mx-2"
            placeholder="Select District"
            v-model="district"
            :options="dist.districtitems"
          />
          <Multiselect
            class="text-sm w-56 focus:border-0 h-8 rounded-full mx-2"
            v-model="value"
            :close-on-select="true"
            track-by="name"
            label="name"
            :search="true"
            :options="options"
            placeholder="Hospital Name"
            @select="selectHospital(value)"  :custom-label="postWithTitle"
          >
            <template v-slot:multiplelabel="{ values }">
              <div>
                {{ values }}
              </div>
            </template>
          </Multiselect>
         
        </div> -->
        <!-- <img src="@/assets/icons/notification.svg" class="w-8 h-8 mt-5 p-1 border-r border-gray-150" /> -->
        <span class="border-r border-gray-150"></span>
        <nav-bar-user has-divider>
          <nav-bar-item-label
            class="text-black-250 text-sm"
            label="Supreme Admin"
          >
          </nav-bar-item-label>
          <img
            v-if="profileitems?.profileImage"
            :src="profileitems?.profileImage"
            class="w-10 h-10 border-2 border-pink-250 rounded-full mr-1"
          />
          <img
            v-else
            class="w-10 h-10 border-2 border-pink-250 rounded-full mr-1"
            src="@/assets/icons/user-pic.svg"
          />
          <template #dropdown>
           <nav-bar-item to="/profile">
              <nav-bar-item-label :icon="mdiAccount" label="My Profile" />
            </nav-bar-item>
            <nav-bar-item @click.prevent="logout()">
              <nav-bar-item-label :icon="mdiLogout" label="Log Out" />
            </nav-bar-item>
          </template>
        </nav-bar-user>
      </div>
    </div>
  </nav>
</template>

<script>
import { computed, ref, toRaw, unref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { reactive, onErrorCaptured } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  mdiThemeLightDark,
  mdiForwardburger,
  mdiBackburger,
  mdiClose,
  mdiMenu,
  mdiDotsVertical,
} from "@mdi/js";
import NavBarItem from "@/components/NavBarItem.vue";
import NavBarItemLabel from "@/components/NavBarItemLabel.vue";
import NavBarMenu from "@/components/NavBarMenu.vue";
import NavBarUser from "@/components/NavBarUser.vue";
import Divider from "@/components/Divider.vue";
import Field from "@/components/Field.vue";
import ControlList from "@/components/ControlList.vue";
import Icon from "@/components/Icon.vue";
import NavBarSearch from "@/components/NavBarSearch.vue";
import NavBarTitle from "@/components/NavBarTitle.vue";
import SearchBox from "@/components/SearchBox.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import AuthService from "@/api/authService";
import { useToast } from "vue-toastification";
import Public from "@/api/public";
import Institute from "@/api/institute";
import Account from "@/api/account";
import Multiselect from "@vueform/multiselect";
export default {
  components: {
    NavBarItem,
    NavBarItemLabel,
    NavBarMenu,
    NavBarUser,
    Divider,
    Field,
    ControlList,
    Icon,
    NavBarSearch,
    NavBarTitle,
    SearchBox,
    MultiSelect,
    Multiselect,
  },
  data() {
    return {
      value: null,
      options: [],
    };
  },
  created() {
    this.getHospital();
  },
  methods: {
    getHospital() {
      Institute.getAll({ all: true }).then((data) => {
        this.options = data.data;
      });
    },
    postWithTitle(options) {
      console.log("option", option);
      console.log("options", options);
      return `${options.id} - [${options.name}]`;
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const toast = useToast();
    const hospitalSelected = ref({});
    // State List Fetching
    var stateList = reactive({ value: [] });
    const currentState = ref("");
    var options = [];
    const hospitalList = ref([]);
    var profileList = reactive({ value: [] });
    const hospital = reactive({ detail: {} });
    onMounted(() => {
      //
      hospital.detail = store.state.currentHospital;
      console.log("HospitalDetail", hospital.detail);
      // Get All Hospital List
      Institute.getAll({ all: true }).then((data) => {
        hospitalList.value = data?.data?.insititutes;
        store.commit("setHospitalList", {
          insititutes: data?.data?.insititutes,
        });
      });
      // Get State List
      Public.get().then((data) => {
        console.log("data", data);
        stateList.value = data?.data;
        console.log("stateList", stateList);
      });
      // Get Profile Details
      Account.get().then((data) => {
        profileList.value = data?.data;
        console.log("profileList", profileList.value);
        console.log("profileitems", profileitems);
      });
    });
    // Profile List Store
    const profileitems = computed(() => {
      return profileList.value;
    });
    // Store StateList
    const stateitems = computed(() => {
      return stateList.value;
    });

    // Current Hospital Title
    const titleitems = computed(() => {
      return store.state.title;
    });

    // Store District List
    const dist = reactive({ districtitems: [] });
    const loadDistrict = () => {
      Public.getAll(currentState.value).then((data) => {
        console.log("district", data);
        if (data?.success) {
          console.log("result", data?.success);
          dist.districtitems = data?.data;
        }
      });
    };
    const lightBorderStyle = computed(() => store.state.lightBorderStyle);
    const toggleLightDark = () => {
      store.dispatch("darkMode");
    };

    const isNavBarVisible = computed(() => !store.state.isFullScreen);
    const isAsideMobileExpanded = computed(
      () => store.state.isAsideMobileExpanded
    );
    const userName = computed(() => store.state.userName);
    const menuToggleMobileIcon = computed(() =>
      isAsideMobileExpanded.value ? mdiBackburger : mdiForwardburger
    );

    const menuToggleMobile = () => store.dispatch("asideMobileToggle");

    const isMenuNavBarActive = ref(false);

    const menuNavBarToggleIcon = computed(() =>
      isMenuNavBarActive.value ? mdiClose : mdiDotsVertical
    );

    const menuNavBarToggle = () => {
      isMenuNavBarActive.value = !isMenuNavBarActive.value;
    };

    const menuOpenLg = () => {
      store.dispatch("asideLgToggle", true);
    };

    const logout = () => {
      AuthService.logout();
      router.push("/");
    };

    // Hospital Details Page
    const goToDashboard = () => {
      router.push({ path: `/staff-list${id}` });
    };
    const selectHospital = (val) => {
      console.log("selected hospital", val);
    };

    return {
      router,
      dist,
      route,
      store,
      toast,
      hospitalSelected,
      stateList,
      currentState,
      hospitalList,
      profileList,
      profileitems,
      stateitems,
      titleitems,
      loadDistrict,
      isNavBarVisible,
      isAsideMobileExpanded,
      menuToggleMobileIcon,
      menuToggleMobile,
      isMenuNavBarActive,
      menuNavBarToggleIcon,
      userName,
      menuNavBarToggle,
      menuOpenLg,
      logout,
      selectHospital,
      
    };
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
